import { render, staticRenderFns } from "./PermissionDialog.vue?vue&type=template&id=11c90978&scoped=true&"
import script from "./PermissionDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c90978",
  null
  
)

export default component.exports